import React, { PureComponent } from "react";
import "./App.css";
import Introduction from "../Introduction";
// import Insults from "./Insults";
import Safeword from "../Safeword";
import Webcam from "../Webcam";
import Info from "../Info";

class App extends PureComponent {
  state = {
    scenes: [Info, Introduction, Safeword, Webcam],
    deviceIsUnsupported: "createTouch" in document,
    safeword: "",
    safewordTyped: "",
    isSafewordAgreed: false,
    isSafewordTriedOut: false,
    isSafewordShouted: false,
    dimensions: {
      width: window.innerWidth,
      height: window.innerHeight
    },
    zIndex: 0,
    webcamEnabled: false
  };

  componentDidMount() {
    window.addEventListener("resize", this.onResize, { passive: true });
    this.onResize();
    this.fetchHits();
  }

  fetchHits() {
    fetch(`/.netlify/functions/count`)
      .then(res => res.json())
      .then(({ hits }) => this.setState({ hits }))
      .catch(err => /* ignore err */ null);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.onResize);
  }

  setAppState = state => {
    this.setState(state, () => console.log(this.state));
  };

  pushScene = scene => {
    this.setState(state => ({
      scenes: [...state.scenes, scene]
    }));
  };

  popScene = sceneToPop => {
    this.setState(({ scenes }) => ({
      scenes: scenes.filter(scene => scene !== sceneToPop)
    }));
  };

  getZIndex = () => {
    const zIndex = this.state.zIndex + 1;
    this.setAppState({ zIndex });
    return zIndex;
  };

  onResize = () => {
    this.setAppState({
      dimensions: {
        width: window.innerWidth,
        height: window.innerHeight
      }
    });
  };

  render() {
    return (
      <React.Fragment>
        {this.state.scenes.map((Scene, i) => (
          <Scene
            key={Scene.name}
            {...this.state}
            getZIndex={this.getZIndex}
            setAppState={this.setAppState}
            pushScene={this.pushScene}
            popScene={this.popScene}
          />
        ))}
      </React.Fragment>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.js